import React from "react";
import { Link } from 'react-router-dom';
import './HeroNew.css';

const Hero = () => {
  return (
    <section className="new-hero">
      <div className="new-hero-content">
        <h1>FAITH TABERNACLE CHURCH</h1>
        <h2>A Christ-centred church dedicated to sharing God's unconditional love across Northamptonshire</h2>
        <Link to="/about" className="visit-button">Our Mission</Link>
      </div>
    </section>
  );
};

export default Hero;
